import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  GLOBAL_STATE,
  WORK_PLAN_ASSIGNED_ALL,
  WORK_PLAN_CREATE,
  WORK_PLAN_CREATED_ALL,
  WORK_PLAN_DELETE,
  WORK_PLAN_STAFF_LIST,
  WORK_PLAN_UPDATE,
  WORK_PLAN_UPDATE_STATUS,
} from '../constants/actionTypes'

const Selectors = (state: RootState) => prop(GLOBAL_STATE, state)

export const workPlanCreatedAllSelector = createSelector(Selectors, prop(WORK_PLAN_CREATED_ALL))

export const workPlanCreateSelector = createSelector(Selectors, prop(WORK_PLAN_CREATE))

export const workPlanDeleteSelector = createSelector(Selectors, prop(WORK_PLAN_DELETE))

export const workPlanUpdateSelector = createSelector(Selectors, prop(WORK_PLAN_UPDATE))

export const workPlanUpdateStatusSelector = createSelector(Selectors, prop(WORK_PLAN_UPDATE_STATUS))

export const workPlanAssignedAllSelector = createSelector(Selectors, prop(WORK_PLAN_ASSIGNED_ALL))

export const workPlanStaffListSelector = createSelector(Selectors, prop(WORK_PLAN_STAFF_LIST))
